export default __webpack_public_path__ + "static/media/automaint3.0e25006a.jpg";